module.exports = __webpack_public_path__ + "media/images/icons/layers-1b8db9896c76913ad443dd6a38733b42.svg";